// eslint-disable-next-line no-restricted-imports
import { gql } from 'apollo-boost';

export const WORKSPACE_FIELDS = gql`
  fragment WorkspaceFields on Workspace {
    id
    name
    uuid
    keyPrefix
    timezone
    type
    cloudId
    organisationId
    goalScoringMode
    type
  }
`;

export const GET_USER_WORKSPACE_DATA_BY_CONTEXT = gql`
  query UserWorkspaceByContext($workspaceContext: WorkspaceContextInput) {
    userWorkspaceByContext(workspaceContext: $workspaceContext) {
      workspace {
        ...WorkspaceFields
        cloudUrl
      }
      requestedContextMatchedType
    }
    workspaceCount {
      recordCount
    }
  }

  ${WORKSPACE_FIELDS}
`;
